<app-header [activeSite]="'forest'"></app-header>

<ion-content [fullscreen]="true">
    <ion-header collapse="condense">
        <ion-toolbar>
            <ion-title size="large">Forest</ion-title>
        </ion-toolbar>
    </ion-header>
    <div class="content">
        <ion-grid>
            <ion-row>
                <ion-col>
                    <app-plant-canvas *ngIf="plantData" [plantData]="plantData" [amount]="amount"></app-plant-canvas>
                    <ion-card class="ion-no-margin ion-margin-vertical">
                        <ion-card-header>
                            <ion-card-title>
                                Batami List
                            </ion-card-title>
                            <ion-card-subtitle>
                                Click on a batami to find out more
                            </ion-card-subtitle>
                        </ion-card-header>
                        <ion-card-content>
                            <ion-list>
                                <ion-item *ngFor="let batami of batamis" button routerLink="/tabs/batami">
                                    <ion-avatar slot="start">
                                        <img [src]="batami.img">
                                    </ion-avatar>
                                    <ion-label>
                                        <h2>{{batami.name}}</h2>
                                        <h3>{{batami.gardeners}}</h3>
                                        <p>Plant Status: {{batami.health | titlecase}}</p>
                                    </ion-label>
                                </ion-item>
                            </ion-list>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button>
            <ion-icon name="people"></ion-icon>
        </ion-fab-button>
        <ion-fab-list side="top">
            <ion-fab-button (click)="openChat()">
                <ion-icon name="chatbubble-ellipses"></ion-icon>
            </ion-fab-button>
            <ion-fab-button (click)="openCanvas()">
                <ion-icon name="brush"></ion-icon>
            </ion-fab-button>
        </ion-fab-list>
    </ion-fab>
</ion-content>
